function getOrderOnlineLink(title) {
  const linkMap = {
    // "p-prairie-donair-airdrie": "https://prairiedonair.gpr.globalpaymentsinc.ca/menu/?deliveryInstructions=&locationId=34174&orderMethod=3&orderType=1&pickupCurbside=false",
    // "p-prairie-donair-crowfoot": "https://prairiedonair.gpr.globalpaymentsinc.ca/menu/?deliveryInstructions=&locationId=34167&orderMethod=3&orderType=1&pickupCurbside=false",
    // "p-prairie-donair-deer-ridge": "https://prairiedonair.gpr.globalpaymentsinc.ca/menu/?deliveryInstructions=&locationId=34164&orderMethod=3&orderType=1&pickupCurbside=false",
    
    // "p-subexpress-regina-quance":"N/A",
  };
  
  return linkMap[title] || `https://orders.iorders.online/${title}`;
}

// ... rest of the code remains unchanged
const storeDetails = {
  status: "success",
  data: {
    restaurants: [
      //1. Cosmic Pizza & Donair Saskatoon
      {
        profile: {
          id: 124,
          restaurant_name: "Cosmic Pizza & Donair Saskatoon SK",
          title: "p-cosmic-pizza-donair-saskatoon",
          address: "1164 Baltzan Blvd, Saskatoon, SK S7W 1K4",
          phone: "+1 (306) 986-6633",
          available_days: [
            {
              id: 1746,
              day: "SUNDAY",
              opening_time: "11:00:00",
              closing_time: "23:00:00",
              order_mode: 1,
            },
            {
              id: 1747,
              day: "MONDAY",
              opening_time: "10:30:00",
              closing_time: "23:00:00",
              order_mode: 1,
            },
            {
              id: 1748,
              day: "TUESDAY",
              opening_time: "10:30:00",
              closing_time: "23:00:00",
              order_mode: 1,
            },
            {
              id: 1749,
              day: "WEDNESDAY",
              opening_time: "10:30:00",
              closing_time: "23:00:00",
              order_mode: 1,
            },
            {
              id: 1750,
              day: "THURSDAY",
              opening_time: "10:30:00",
              closing_time: "23:00:00",
              order_mode: 1,
            },
            {
              id: 1751,
              day: "FRIDAY",
              opening_time: "10:30:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1752,
              day: "SATURDAY",
              opening_time: "10:30:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
          ],
          close_restaurent: false,
          lat: "52.170094859649225",
          lng: "-106.55435191736382",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },
      //2. Cosmic Pizza & Donair Windermere
      {
        profile: {
          id: 124,
          restaurant_name: "Cosmic Pizza & Donair Windermere Edmonton",
          title: "p-cosmic-pizza-donair-windermere",
          address: "17316 Hiller Rd SW, Edmonton, AB T6W 4H3",
          phone: "+1 (780) 581-1713",
          available_days: [
            {
              id: 1746,
              day: "SUNDAY",
              opening_time: "12:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1747,
              day: "MONDAY",
              opening_time: "10:30:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1748,
              day: "TUESDAY",
              opening_time: "10:30:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1749,
              day: "WEDNESDAY",
              opening_time: "10:30:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1750,
              day: "THURSDAY",
              opening_time: "10:30:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1751,
              day: "FRIDAY",
              opening_time: "10:30:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1752,
              day: "SATURDAY",
              opening_time: "00:01:00",
              closing_time: "02:00:00",
              order_mode: 1,
            },
            {
              id: 1752,
              day: "SATURDAY",
              opening_time: "10:30:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1746,
              day: "SUNDAY",
              opening_time: "00:01:00",
              closing_time: "02:00:00",
              order_mode: 1,
            },
          ],
          close_restaurent: false,
          lat: "53.42172114111474",
          lng: "-113.61927785339174",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },
      //3. Cosmic Pizza & Donair Heritage
      {
        profile: {
          id: 124,
          restaurant_name: "Cosmic Pizza & Donair Heritage Calgary",
          title: "p-cosmic-pizza-donair-heritage",
          address: "347 Heritage Dr SE, Calgary, AB T2H 1M8",
          phone: "+1 (780) 789-0406",
          available_days: [
            {
              id: 1746,
              day: "SUNDAY",
              opening_time: "12:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1747,
              day: "MONDAY",
              opening_time: "10:30:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1748,
              day: "TUESDAY",
              opening_time: "10:30:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1749,
              day: "WEDNESDAY",
              opening_time: "10:30:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1750,
              day: "THURSDAY",
              opening_time: "10:30:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1751,
              day: "FRIDAY",
              opening_time: "10:30:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1752,
              day: "SATURDAY",
              opening_time: "10:30:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
          ],
          close_restaurent: false,
          lat: "50.97875718315754",
          lng: "-114.0618985351414",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },
      //4. Cosmic Pizza & Donair 54 ave SW
      {
        profile: {
          id: 124,
          restaurant_name: "Cosmic Pizza & Donair 54 Ave SW Calgary",
          title: "p-cosmic-pizza-donair-54-ave-sw",
          address: "2439 54 Ave SW #20a, Calgary, AB T3E 1M4",
          phone: "+1 (403) 984-3949",
          available_days: [
            {
              id: 1746,
              day: "SUNDAY",
              opening_time: "12:00:00",
              closing_time: "23:00:00",
              order_mode: 1,
            },
            {
              id: 1747,
              day: "MONDAY",
              opening_time: "10:00:00",
              closing_time: "23:00:00",
              order_mode: 1,
            },
            {
              id: 1748,
              day: "TUESDAY",
              opening_time: "10:00:00",
              closing_time: "23:00:00",
              order_mode: 1,
            },
            {
              id: 1749,
              day: "WEDNESDAY",
              opening_time: "10:00:00",
              closing_time: "23:00:00",
              order_mode: 1,
            },
            {
              id: 1750,
              day: "THURSDAY",
              opening_time: "10:00:00",
              closing_time: "23:00:00",
              order_mode: 1,
            },
            {
              id: 1751,
              day: "FRIDAY",
              opening_time: "10:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1752,
              day: "SATURDAY",
              opening_time: "10:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
          ],
          close_restaurent: false,
          lat: "51.0046951",
          lng: "-114.1216703",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },
      //5. Cosmic Pizza & Donair - 34 Street
      {
        profile: {
          id: 124,
          restaurant_name: "Cosmic Pizza & Donair 34 Street NW Edmonton",
          title: "cosmic-pizza-donair-34-street-edmonton-5009",
          address: "3313 34 Street Northwest, Edmonton, AB, Canada",
          phone: "+1 (587) 635-6607",
          available_days: [
            {
              id: 1746,
              day: "SUNDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1746,
              day: "SUNDAY",
              opening_time: "12:00:00",
              closing_time: "02:00:00",
              order_mode: 1,
            },
            {
              id: 1747,
              day: "MONDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1747,
              day: "MONDAY",
              opening_time: "12:00:00",
              closing_time: "02:00:00",
              order_mode: 1,
            },
            {
              id: 1748,
              day: "TUESDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1748,
              day: "TUESDAY",
              opening_time: "12:00:00",
              closing_time: "02:00:00",
              order_mode: 1,
            },
            {
              id: 1749,
              day: "WEDNESDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1749,
              day: "WEDNESDAY",
              opening_time: "12:00:00",
              closing_time: "02:00:00",
              order_mode: 1,
            },
            {
              id: 1750,
              day: "THURSDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1750,
              day: "THURSDAY",
              opening_time: "12:00:00",
              closing_time: "02:00:00",
              order_mode: 1,
            },
            {
              id: 1751,
              day: "FRIDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1751,
              day: "FRIDAY",
              opening_time: "12:00:00",
              closing_time: "02:00:00",
              order_mode: 1,
            },
            {
              id: 1752,
              day: "SATURDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1752,
              day: "SATURDAY",
              opening_time: "12:00:00",
              closing_time: "02:00:00",
              order_mode: 1,
            },
          ],
          close_restaurent: false,
          lat: "53.46231816667071",
          lng: "-113.39262574327797",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },
      //6. Cosmic Pizza & Donair - Nolan
      {
        profile: {
          id: 124,
          restaurant_name: "Cosmic Pizza & Donair Nolan Calgary",
          title: "cosmic-pizza-nolan-hills-calgary-5397",
          address: "150 Nolanridge Ct NW UNIT 145, Calgary, AB T3R 2A8, Canada",
          phone: "+1 (403) 571-8221",
          available_days: [
            {
              id: 1746,
              day: "SUNDAY",
              opening_time: "11:00:00",
              closing_time: "23:00:00",
              order_mode: 1,
            },
            {
              id: 1747,
              day: "MONDAY",
              opening_time: "10:30:00",
              closing_time: "23:00:00",
              order_mode: 1,
            },
            {
              id: 1748,
              day: "TUESDAY",
              opening_time: "10:30:00",
              closing_time: "23:00:00",
              order_mode: 1,
            },
            {
              id: 1749,
              day: "WEDNESDAY",
              opening_time: "10:30:00",
              closing_time: "23:00:00",
              order_mode: 1,
            },
            {
              id: 1750,
              day: "THURSDAY",
              opening_time: "10:30:00",
              closing_time: "23:00:00",
              order_mode: 1,
            },
            {
              id: 1751,
              day: "FRIDAY",
              opening_time: "10:30:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1752,
              day: "SATURDAY",
              opening_time: "10:30:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
          ],
          close_restaurent: false,
          lat: "51.17065022956632",
          lng: "-114.16529032552447",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },
    ],
  },
  message: "successful response",
};

export default storeDetails;
